<div class="dialog__container offers-presentation-dialog"
    [ngClass]="{
        'offers-presentation-dialog--comparison': offersPresentationService.isComparisonMode,
        'offers-presentation-dialog--presentation': offersPresentationService.isDetailsMode,
        'offers-presentation-dialog--next': isNext,
        'offers-presentation-dialog--old': !isNext,
        'offers-presentation-dialog--with-cta': offersPresentationService.buyOnlineButtonVisible,
        'offers-presentation-dialog--shadow': isNext && contentScrolled
    }">
    <div [class]="offersPresentationService.isComparisonMode ? ['dialog__header dialog__header--comparison'] : 'dialog__header' ">

        <div class="two-container">
            <div class="dialog__title">
                <span class="dialog__title--text">{{ offersPresentationService.dialogTitle | translate }}</span>
            </div>

            <div *ngIf="offersPresentationService.sendOfferNumberEnabled" class="dialog__action">
                <app-send-offer [context]="offerNumberContext"
                                class="send-offer-presentation"></app-send-offer>
            </div>
        </div>
        <div class="dialog__close" (click)="close()" cdkFocusRegionstart>
            <span class="material-icons">close</span>
        </div>
    </div>

    <div class="table-container"
         [ngClass]="{'table-container--with-quotation': offersPresentationService.hasQuotationId}">
        <table class="general-table"
               [ngClass]="{
                'general-table__comparison' : offersPresentationService.isComparisonMode,
                'table-with-one-offer': offersPresentationService.offersAmount == 1,
                'table-with-two-offer': offersPresentationService.offersAmount == 2,
                'table-with-three-offer': offersPresentationService.offersAmount == 3,
                'table-with-four-offer': offersPresentationService.offersAmount == 4
              }">
            <thead>
            <tr>
                <th [colSpan]="colspanHead"
                    [class]="'colspan-head-length-' + offersPresentationService.offersAmount">
                    <app-shortened-vehicle-info *ngIf="!offersPresentationService.isNext"
                                                [context]="'OFFERS_PRESENTATION'">
                    </app-shortened-vehicle-info>
                    <div *ngIf="isNext"
                         class="offers-presentation-dialog__insurance-data">
                        <app-insurance-data-summary *ngIf="offersPresentationService.isNext"
                                                    [context]="DataSummaryContext.OFFERS_PRESENTATION"
                                                    [headerVisible]="false">
                        </app-insurance-data-summary>
                    </div>
                </th>
                <ng-container *ngFor="let offer of offersPresentationService.offers">
                    <th class="relative table-offer-header">
                        <div class="offer-logo-container">
                            <div class="relative offer-logo-container__wrapper">
                                <img class="table-offer-logo"
                                     *ngIf="offerResourceService.hasOfferLogo(offer)"
                                     [src]="offerResourceService.getOfferLogoUri(offer)">
                                <span class="material-icons offer-logo-container__icon offer__delete-icon"
                                      *ngIf="offersPresentationService.removeOfferVisible"
                                      (click)="offersPresentationService.removeOffer(offer.id)">{{removeIcon}}</span>
                            </div>
                        </div>
                        <app-offer-fixed-price [offer]="offer" [showInstalment]="false"></app-offer-fixed-price>
                        <div *ngIf="isNext"
                             class="table-offer-action-button">
                            <button *ngIf="offersPresentationService.buyOnlineButtonVisible"
                                    class="btn btn--secondary btn--small-padding buy-online offers-presentation__button"
                                    (click)="selectOffer(offer)">
                                {{'OFFER_SECTION.SHARED.buyOnline' | translate}} <span *ngIf="!isNext">&#62;&#62;</span>
                            </button>
                        </div>
                    </th>
                </ng-container>

            </tr>
            </thead>
            <tbody>
            <tr class="table-border" *ngFor="let groupOffer of offersPresentationService.coverageGroups">
                <td [colSpan]="offersPresentationService.colSpan">
                    <app-offer-presentation-group-box [offers]="offersPresentationService.offers"
                                                      [groupOffer]="groupOffer"></app-offer-presentation-group-box>
                </td>
            </tr>
            </tbody>
            <tbody class="no-shadow no-before">
            <tr>
                <td [colSpan]="offersPresentationService.colSpan"
                    [class.border-bottom]="!isNext"
                    class="no-padding">
                    <table>
                        <tbody>
                        <tr>
                            <td [colSpan]="colspanFooter"
                                [class]="'colspan-head-length-' + offersPresentationService.offersAmount">
                                {{'OFFER_SECTION.COMPARE.generalInsuranceConditions' | translate}}
                            </td>
                            <ng-container *ngFor="let offer of offersPresentationService.offers">
                                <td class="text-center ">
                                    <a class="offer-download offer-download--kioskpolis" target="_blank"
                                       [href]="offerResourceService.getOfferOWUUri(offer)">
                                        <img alt="" class="table-offer-img" [src]="downloadOWUButtonIcon">
                                        <span>{{downloadOWUButtonLabel | translate}}</span>
                                    </a>
                                    <a class="offer-download offer-download--yanosik" target="_blank"
                                       [href]="offerResourceService.getOfferOWUUri(offer)">
                                        <img alt="" class="table-offer-img" src="./assets/images/icons/owu-yanosik.svg">
                                    </a>
                                </td>
                            </ng-container>
                        </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
            </tbody>
            <tfoot *ngIf="!isNext">
                <tr>
                    <td class="table-td-title" [colSpan]="colspanHead">{{'OFFER_SECTION.COMPARE.policyPrice' | translate}}
                    </td>
                    <td *ngFor="let offer of offersPresentationService.offers; let i = index" class="offers-presentation__row">
                        <div class="table-offer-action">
                            <div class="table-offer-action-group">
                                <div class="table-offer-action-logo">
                                    <img alt="" class="table-offer-logo"
                                         [src]="offerResourceService.getOfferLogoUri(offer)">
                                </div>
                                <div class="table-offer-action-price">
                                    <app-offer-fixed-price [offer]="offer" [showInstalment]="false"></app-offer-fixed-price>
                                    <div class="custom-price-container first-pay">
                                        {{'OFFER_SECTION.COMPARE.firstInstallment' | translate}}
                                        <span class="bold"> {{offer | lowestFirstInstalment}} {{'OFFER_SECTION.SHARED.currencyShortcut' | translate}}</span>
                                    </div>
                                </div>
                                <div class="table-offer-action-button">
                                    <button *ngIf="offersPresentationService.buyOnlineButtonVisible"
                                            class="btn btn--secondary btn--small-padding buy-online offers-presentation__button"
                                            (click)="selectOffer(offer)">
                                        {{'OFFER_SECTION.SHARED.buyOnline' | translate}} <span>&#62;&#62;</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>

</div>
